import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Modal } from "@cars24/turbo-web/lib/modal";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { NUMBER } from "../../../constants/app-constants";
import RtoVehInfoQuestionList from "../../shared/rto-veh-info-question-list";
import Lottie from "./images/lottie.png";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import AdsComponent from "../../shared/ads";
import { appUrl } from "../../../constants/url-constants";

const VERSION = "v5";

const RtoVehInfoQuestionContainer = ({
    questions,
    cmsImageGallery,
    fetchRtoQuestionsConnect,
    saveRtoQuestionConnect
}) => {
    const { challenge = [] } = cmsImageGallery || {};
    const { tokens } = useTokens();
    const [isOpen, setIsOpen] = useState(false);
    const [askQuestions, setAskQuestions] = useState(false);

    const onOpen = () => {
        setIsOpen(true);
    };

    const openQuestions = async () => {
        onOpen();
        await yieldToMain();
        sendCustomGaEvents({
            event: "rto_accept_challenge_clicked",
            eventCategory: "rto_accept_challenge_clicked",
            eventAction: "Accept Challenge clicked"
        });
        fetchRtoQuestionsConnect(VERSION).then(() => {
            window.setTimeout(() => {
                setAskQuestions(true);
            }, NUMBER.THOUSAND);
        });
    };

    const handleQuestionClose = () => {
        setAskQuestions(false);
        setIsOpen(false);
    };

    if ((challenge || []).length === NUMBER.ZERO) return null;

    return (
        <div>
            <img src={challenge[0].desktopImage} alt="rto-challenge" onClick={openQuestions} styleName={"styles.rtoChallenge"} />
            {
                <Modal
                    showCloseButton={false}
                    isOpen={isOpen}
                    onClose={() => {handleQuestionClose();}}
                    overlayColor={tokens.background_surface_overlay_primary}
                    width={"600px"}
                    height={"664px"}
                >
                    {
                        askQuestions && !!(questions || []).length ?
                            <RtoVehInfoQuestionList handleClose={handleQuestionClose} version={VERSION} saveRtoQuestionConnect={saveRtoQuestionConnect}/> :
                            <div styleName={"styles.thinkingPopup"}>
                                <img src={Lottie} alt="Lottie" />
                                <Heading level={NUMBER.FOUR}>Put on your thinking cap</Heading>
                                <BodyText level={NUMBER.TWO}>See how high you can score on the<br/>ultimate knowledge challenge!</BodyText>
                                <div styleName="styles.adsContainerInPage">
                                    <AdsComponent
                                        platformType="DESKTOP"
                                        url={`${appUrl()}/rto-vehicle-registration-details/`}
                                        slotName= "cars24_rto_traffic_quiz_320x100"
                                        bu = "rto"
                                        expand = "YES"
                                        width = {320}
                                        height = {100}
                                        shouldLoaderMobileLoader={true}
                                    />
                                </div>
                            </div>
                    }
                </Modal>
            }
        </div>
    );
};

RtoVehInfoQuestionContainer.propTypes = {
    questions: PropTypes.array,
    cmsImageGallery: PropTypes.object,
    fetchRtoQuestionsConnect: PropTypes.func,
    saveRtoQuestionConnect: PropTypes.func
};

export default RtoVehInfoQuestionContainer;
